import { useInstantSearch } from 'react-instantsearch'

// All supported refinement types
const refinementKeys = [
  'hierarchicalMenu',
  'refinementList',
  'range',
  'toggle',
  'menu',
  'numericMenu',
  'sortBy',
  'query',
  'page',
]

/**
 * --------------------------------------------------------------------------
 * Check if there are any filters applied (including page, sort and keyword search)
 * --------------------------------------------------------------------------
 **/
export const checkIsFiltered = ({
  includePage = true,
}: { includePage?: boolean } = {}): boolean => {
  const { uiState } = useInstantSearch()

  const filters = Object.values(uiState)[0] || {}

  return refinementKeys.some((key) => {
    if (!includePage && key === 'page') {
      return false
    }
    return Boolean(filters[key])
  })
}

/**
 * --------------------------------------------------------------------------
 * Get the total count of filters applied
 * --------------------------------------------------------------------------
 **/
export const getFilterCount = () => {
  const { uiState } = useInstantSearch()

  const filters = Object.values(uiState)[0] || {}

  let count = 0

  for (const key of refinementKeys) {
    const filterValue = filters[key] || null

    if (filterValue) {
      const values = Array.isArray(filterValue) ? Object.values(filterValue) : filterValue
      const flattenedValues = Array.isArray(values) ? values.flat() : [values]

      count += flattenedValues.length
    }
  }

  return count
}

/**
 * --------------------------------------------------------------------------
 * Get the list of filters applied
 * --------------------------------------------------------------------------
 **/
export const getFilterValues = () => {
  const { uiState } = useInstantSearch()

  const filters = Object.values(uiState)[0] || {}

  return filters
}
